const NS = 'CurrentPodcastWidget';
const CLS = 'currentPodcastWidget';

export class CurrentPodcastWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.audioElement = this.element.getElementsByTagName('audio')[0];

		// Play the audio onload
		//this.audioElement.play();

		// get clicks on play/pause buttons
		this.$element.on('click', '.play-button', (e) => {
			// both buttons
			this.$element.find('.play-button').toggleClass('active');
			// enough to check only one button
			if($(e.currentTarget).hasClass('active')) {
				this.audioElement.play();
			}
			else {
				this.audioElement.pause();
			}

			// remove focus state styles
			this.$element.find('.play-button').trigger('blur');
		});

		this.audioElement.addEventListener('play', () => {
			this.$element.find('.play-button').addClass('active');
		});

		this.audioElement.addEventListener('pause', () => {
			this.$element.find('.play-button').removeClass('active');
		});
	}
}
